import { validatable } from '../mixins/validation'
import { observable, computed, action } from 'mobx'
import { serializable, serialize, snapshotable } from '../data/serialization'
import { receiveErrors } from '../data/serverErrors'
import { Types } from '../data/Type'
import RynoEditor from '../ryno-editor/RynoEditor'
import { func } from 'validx'

/**
 * Pending config editor.
 */
@snapshotable
@validatable({ liveValidation: true })
export default class PendingConfigEditor {
  @observable
  @serializable
  enabled_expr

  @observable
  @serializable
  advance_date_expr

  rules = {
    enabled_expr: [
      func((ctx) => ctx.value.analyze(), 'There are formula errors.'),
    ],
    advance_date_expr: [
      func((ctx) => ctx.value.analyze(), 'There are formula errors.'),
    ],
  }

  constructor(legendEditor) {
    this.legendEditor = legendEditor
    this.enabled_expr = new RynoEditor({
      getSymbolTable: () => this.symbolTable,
      getNeededType: () => Types.boolean,
    })
    this.advance_date_expr = new RynoEditor({
      getSymbolTable: () => this.symbolTable,
      getNeededType: () => Types.date,
    })
  }

  @computed
  get symbolTable() {
    return this.legendEditor.getSymbolTableFor(this)
  }

  hydrate(pendingConfig) {
    if (!pendingConfig) {
      this.enabled_expr.setValue('')
      this.advance_date_expr.setValue('')
      return
    }

    const { enabled_expr, advance_date_expr } = pendingConfig
    this.enabled_expr.setValue(enabled_expr, true)
    this.advance_date_expr.setValue(advance_date_expr, true)
  }

  @action.bound
  useFixedDateTemplate() {
    const month = 1
    const day = 12
    const now = new Date()
    const thisYear = now.getFullYear()
    // Use this year if the date is still ahead of us, otherwise next year.
    const year =
      now < new Date(thisYear, month - 1, day) ? thisYear : thisYear + 1
    this.advance_date_expr.setValue(
      `
# Using the Time module, build an exact date from year, month and day.
Time.Of(
  # The year.
  ${year}
  # The month, where 1 is January.
  ${month}
  # The day of the month.
  ${day}
)
      `.trim()
    )
  }

  @action.bound
  useRelativeDateTemplate() {
    this.advance_date_expr.setValue(
      `
# Using the Time module, add 3 months to the request's submission date.
Time.AddMonths(
  # Refers to the request's submission date.
  Request.DateSubmitted
  # The amount of months to add to the aforementioned date.
  3
)
      `.trim()
    )
  }

  toJSON() {
    return serialize(this)
  }

  receiveErrors(descriptor = {}) {
    const { inner = {} } = descriptor
    receiveErrors(this, inner)
  }
}
